import React from 'react';
import { Link } from 'react-router-dom';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { MIDTOWN_FAQ, AYUMI_IMG, STUDIO } from './midtownData';

const MidtownFaq = () => (
  <section className="py-20" data-testid="midtown-faq">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-xs tracking-[0.25em] uppercase text-teal-700">Questions</p>
      <h2 className="mt-3 text-3xl md:text-4xl font-serif text-gray-900">Midtown massage, answered.</h2>
      <Accordion type="single" collapsible className="mt-8">
        {MIDTOWN_FAQ.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`midtown-faq-item-${i}`}>
            <AccordionTrigger className="text-left text-base md:text-lg font-serif text-gray-900" data-testid={`midtown-faq-trigger-${i}`}>{f.q}</AccordionTrigger>
            <AccordionContent className="text-gray-700 leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-16 bg-teal-700 text-white rounded-[2rem] p-8 md:p-12 flex flex-col md:flex-row items-center gap-8" data-testid="midtown-final-cta">
        <img src={AYUMI_IMG} alt="Ayumi Suzuki, CAMTC-certified massage therapist in Midtown Sacramento" className="w-28 h-28 rounded-full object-cover ring-4 ring-white/30" />
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-2xl md:text-3xl font-serif">See you in Midtown.</h2>
          <p className="mt-2 text-white/85">{STUDIO.street} · {STUDIO.hours}</p>
        </div>
        <Link to="/book" className="bg-white text-teal-800 px-8 py-4 rounded-full hover:bg-rose-50 transition-colors duration-300 whitespace-nowrap" data-testid="midtown-final-book-btn">
          Book now
        </Link>
      </div>
    </div>
  </section>
);

export default MidtownFaq;
